import { testimonials } from '@/mocks/data';

export default function TestimonialsSection() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-3">
            真实口碑
          </span>
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 mb-3">
            超过10万家庭的信赖之选
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            听听爸爸妈妈和奶奶们怎么说
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((item) => (
            <div key={item.id} className="bg-background-50 rounded-xl p-6 border border-background-200/70">
              <div className="flex items-center gap-3 mb-4">
                <img
                  src={item.avatar}
                  alt={item.name}
                  className="w-10 h-10 rounded-full object-cover"
                  loading="lazy"
                />
                <div>
                  <div className="text-sm font-medium text-foreground-900">{item.name}</div>
                  <div className="text-xs text-foreground-500">{item.city}</div>
                </div>
              </div>
              <div className="flex gap-0.5 mb-3">
                {Array.from({ length: item.rating }).map((_, i) => (
                  <i key={i} className="ri-star-fill text-secondary-400 text-sm"></i>
                ))}
              </div>
              <p className="text-foreground-700 text-sm leading-relaxed">{item.content}</p>
            </div>
          ))}
        </div>

        <div className="mt-10 flex flex-wrap items-center justify-center gap-8 md:gap-14">
          <div className="text-center">
            <div className="font-heading text-2xl md:text-3xl text-primary-500">100,000+</div>
            <div className="text-xs text-foreground-500 mt-1">服务家庭</div>
          </div>
          <div className="text-center">
            <div className="font-heading text-2xl md:text-3xl text-accent-500">98.6%</div>
            <div className="text-xs text-foreground-500 mt-1">好评率</div>
          </div>
          <div className="text-center">
            <div className="font-heading text-2xl md:text-3xl text-secondary-500">30+</div>
            <div className="text-xs text-foreground-500 mt-1">专家团队</div>
          </div>
          <div className="text-center">
            <div className="font-heading text-2xl md:text-3xl text-primary-500">365天</div>
            <div className="text-xs text-foreground-500 mt-1">全年陪伴</div>
          </div>
        </div>
      </div>
    </section>
  );
}